import React, { useEffect, useState, useRef } from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import TabPoly from "./TabPoly";
import TabIron from "./TabIron";
import TabFolding from "./TabFolding";
import {
  FireOutlined,
  ScissorOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import "./Tabs.css";

const Tab = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const ironRef = useRef();
  const foldingRef = useRef();
  const polyRef = useRef();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");

    let newActiveTab = "1";
    let tabName = "iron";

    if (tabParam) {
      switch (tabParam.toLowerCase()) {
        case "iron":
          newActiveTab = "1";
          tabName = "iron";
          break;
        case "folding":
          newActiveTab = "2";
          tabName = "folding";
          break;
        case "poly":
          newActiveTab = "3";
          tabName = "poly";
          break;
        default:
          newActiveTab = "1";
          tabName = "iron";
      }
    }

    setActiveTab(newActiveTab);

    if (!tabParam) {
      navigate(`?tab=${tabName}`, { replace: true });
    }
  }, [location.search, navigate]);

  const handleTabChange = (key) => {
    let tabName;

    switch (key) {
      case "1":
        tabName = "iron";
        if (
          ironRef.current &&
          typeof ironRef.current.fetchData === "function"
        ) {
          ironRef.current.fetchData();
        }
        break;
      case "2":
        tabName = "folding";
        if (
          foldingRef.current &&
          typeof foldingRef.current.fetchData === "function"
        ) {
          foldingRef.current.fetchData();
        }
        break;
      case "3":
        tabName = "poly";
        if (
          polyRef.current &&
          typeof polyRef.current.fetchData === "function"
        ) {
          polyRef.current.fetchData();
        }
        break;
      default:
        tabName = "iron";
    }

    navigate(`?tab=${tabName}`, { replace: true });
    setActiveTab(key);
  };

  // More compact tabs with smaller icons for better spacing
  const tabItems = [
    {
      key: "1",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <FireOutlined style={{ marginRight: 4 }} />
          <strong style={{ fontSize: "16px" }}>Iron</strong>
        </span>
      ),
      children: <TabIron ref={ironRef} />,
    },
    {
      key: "2",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ScissorOutlined style={{ marginRight: 4 }} />
          <strong style={{ fontSize: "16px" }}>Folding</strong>
        </span>
      ),
      children: <TabFolding ref={foldingRef} />,
    },
    {
      key: "3",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <InboxOutlined style={{ marginRight: 4 }} />
          <strong style={{ fontSize: "16px" }}>Poly</strong>
        </span>
      ),
      children: <TabPoly ref={polyRef} />,
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabItems}
        className="full-width-tabs"
        type="card" // Changed to card type for better width distribution
        centered={false} // Disable centered to allow for flex-based width distribution
        size="middle" // Smaller tab size
        tabBarGutter={1} // Reduce the gap between tabs
      />
    </div>
  );
};

export default Tab;
